export default {
  detail: {
    method: "get",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  create: {
    method: "post",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  update: {
    method: "put",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  associatedBranches: {
    method: "get",
    url: "/user/v1/v2/brokers/:code/sections",
  },
  associateBranches: {
    method: "patch",
    url: "/user/v1/v2/brokers/:code/associate-sections",
  }
};
